import model from "../models/systems_health_timeline";
export default () => {
  let data = model();

  return {
    data,
  };
};
